import React, { useState, useEffect, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import LoadingOverlay from 'react-loading-overlay';
import Toolbar from '@material-ui/core/Toolbar';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import AlertAlgo from '../controls/AlertSnack'
import BeatLoader from 'react-spinners/BeatLoader';
import { Company } from '@users';
import ChatDetail from './ChatDetail'
import { ChatContext } from '@/ChatProvider';
import { formatTimestamp } from '@utils/index';
import { isIOS } from '@utils';
import ContactList from './ContactList'
import styles from '@styles/chat.module.css';

const useStyles = makeStyles((theme) => ({
    appBarForm: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important',
    },
    titleAppBarForm: {
        marginLeft: theme.spacing(2),
        flex: 1,
    }
}));

const spanNameValue = {
    display: 'flex',
    marginLeft: 55,
    fontWeight: 'bold',
    justifyContent: 'space-between',
    alignItems: 'center'
};

const spanEmptyTextValue = {
    marginTop: 11,
    marginLeft: 55,
    display: 'flex',
    fontWeight: 'bold'
};

const spanTextValue = {
    marginLeft: 55,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
};

const statusStyle = (onLine) => ({
    position: 'absolute',
    bottom: 3,
    width: 14,
    height: 14,
    borderRadius: '50%',
    backgroundColor: onLine ? '#44b700' : '#B0B3B8',
    border: '2px solid white',
    left: 32
});

const avatarStyle = {
    position: 'relative',
    display: 'table',
    width: '100%',
    height: '50px',
    objectFit: 'cover'
};

const SeparatorDiv = ({ children }) => (
    <div>
        {children}
        <div style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            height: '1px',
            backgroundColor: '#ccc'
        }}></div>
    </div>
);

const ProfileBadge = ({ data }) => {
    return (
        <div style={avatarStyle} title={data.fullName}>
            <div className={styles.profileBadge}>{data.initial}</div>
            <div style={data.text ? spanNameValue : spanEmptyTextValue}>{data.fullName}</div>
            <div style={spanTextValue}>
                <span >{data.text}</span>
                <span>{data.dispachDate}</span>
            </div>
            <div style={statusStyle(data.onLine)} ></div>
        </div>
    );
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function ChatList(props) {
    const classes = useStyles();
    const [data, setData] = useState(null);
    const [dataRow, setDataRow] = useState(null);
    const [filter, setFilter] = useState('');
    const [open, setOpen] = useState(false);
    const [openContactList, setOpenContactList] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const {chatUsers, state} = useContext(ChatContext);    
    const alertRef = useRef(null);
    const [isiOS, setIsiOS] = React.useState(isIOS());

    useEffect(() => {
        setTimeout(() => {//Wait until load page complete
            LoadData();
            setIsActive(false);
        }, 0);
    }, []);

    useEffect(() => {
        LoadData();
    }, [state.messages], [state.latestUsersMessage]);


    useEffect(() => {
        updateStatus();
    }, [state.usersStatus]);

    const handleCloseForm = (value) => {
        if (typeof (value) === 'string') {
            alertRef.current.showMessageSuccess(value);
        }
    };

    const showMessage = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showErrorMessage = (message) => {
        alertRef.current.showMessageError(message);
    }

    const LoadData = () => {
        if (chatUsers) {
            const authorsList = state.messages.map(item => item.author.id);
            const sendersList = state.messages.map(item => item.recipient.id);
            const filteredUsers = Array.from(new Set([...authorsList, ...sendersList]));

            let origList = chatUsers.filter(user =>
                filteredUsers.includes(user.userCode + user.konekUserAssociationId + Company())
            )

            origList = origList.map(user => {

                //Update status
                if (state.usersStatus.includes(user.userCode + user.konekUserAssociationId + Company())) {
                    user.onLine = true;
                } else {
                    user.onLine = false;
                }

                //Update unread messages counter
                user.unReadMessagesCounter = state.messages.filter(x => x.author.id == (user.userCode + user.konekUserAssociationId + Company()) && x.readDate === null).length;

                return user;
            });

            const allUsers = [];
            const sortedUsers = state.latestUsersMessage.map(item => item.author.id);

            state.latestUsersMessage.forEach(user => {
                const curUser = origList.filter(x => (x.userCode + x.konekUserAssociationId + Company()) === user.author.id);
                if (curUser.length > 0) {
                    curUser[0].text = (user.text.length <= 20 ? user.text : user.text.substring(0, 20) + '...');
                    curUser[0].dispachDate = formatTimestamp(user.timestamp);
                    allUsers.push(curUser[0]);
                }
            });

            setData([...allUsers, ...origList.filter(user =>
                !sortedUsers.includes(user.userCode + user.konekUserAssociationId + Company())
            )]);
        }
    }

    const updateStatus = () => {
        if (data) {
            const usersList = data.map(user => {

                if (state.usersStatus.includes(user.userCode + user.konekUserAssociationId + Company())) {
                    user.onLine = true;
                } else {
                    user.onLine = false;
                }

                return user;
            });

            setData(usersList);
        }
    }

    const handleClick = (obj) => {
        setDataRow(obj);
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    const handleContactList = () => {
        setOpenContactList(true);
    }

    const handleCloseClick = () => {
        setOpenContactList(false);
    };

    const filteredList = data?.filter(row =>
        row.fullName.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <div className={styles.konekCard}>
            <LoadingOverlay
                active={isActive}
                spinner={<BeatLoader />}
                text={i18next.t('common:loading')}
            >
                <input
                    type="text"
                    value={filter}
                    onChange={handleFilterChange}
                    placeholder={i18next.t('chat:list.placeholderFilterMessage')}
                    className={styles.filter}
                />
                <List style={{
                    maxHeight: '100%',
                    overflowY: 'auto',
                    padding: 'fixed',
                    position: 'relative',
                    width: '100%'
                }}>
                    {filteredList?.map((obj, index) =>
                        <React.Fragment key={`${index}`}>
                            <div style={{ marginTop: "5px" }}>
                                <ListItem key={`${index}`} button onClick={() => handleClick(obj)}>
                                    <ListItemText disableTypography={true} primary={
                                        <React.Fragment>
                                            <SeparatorDiv>
                                                <ProfileBadge data={obj} />
                                                {obj.unReadMessagesCounter > 0 && <span className={styles.notificationCounter} style={{ top: "15px", right: "0px" }}>{obj.unReadMessagesCounter}</span>}
                                            </SeparatorDiv>
                                        </React.Fragment>
                                    } />
                                </ListItem>
                            </div>
                        </React.Fragment>
                    )}
                </List>

                {dataRow != null && <ChatDetail data={dataRow} open={open} onClose={handleClose} />}
            </LoadingOverlay>
            <Dialog fullScreen open={openContactList} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div data-id="headerContactList">
                    <AppBar className={classes.appBarForm}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBarForm}>
                                {i18next.t('chat:list.contact')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divContactListContainer">
                    <ContactList onClose={handleCloseClick} />
                </div>
            </Dialog>
            <AlertAlgo ref={alertRef} />
            <Fab color="primary" aria-label="add" className={`addButtonFabWithBar ${isiOS && "addButtonFabWithBarIOS"}`} onClick={() => handleContactList()} >
                <AddIcon />
            </Fab>
        </div>
    );
}

export default withNamespaces(['menu', 'chat', 'common', 'error'], { wait: true })(ChatList);